const NotFound: React.FC = () => {
  return <div>Sivua ei löydy</div>;
};

export default NotFound;
